var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15C3.0875 15 2.73438 14.8531 2.44063 14.5594C2.14687 14.2656 2 13.9125 2 13.5V4.5C2 4.0875 2.14687 3.73438 2.44063 3.44063C2.73438 3.14687 3.0875 3 3.5 3H15.5C15.9125 3 16.2656 3.14687 16.5594 3.44063C16.8531 3.73438 17 4.0875 17 4.5V13.5C17 13.9125 16.8531 14.2656 16.5594 14.5594C16.2656 14.8531 15.9125 15 15.5 15H3.5ZM9.5 9.75L3.5 6V13.5H15.5V6L9.5 9.75ZM9.5 8.25L15.5 4.5H3.5L9.5 8.25ZM3.5 6V4.5V13.5V6Z",
    fill: "#6710A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5ec3fe63a70692d6d66d8c22ba494be5.svg";
export { ForwardRef as ReactComponent };